import React, { useCallback, useEffect } from 'react';
import { AddingCustomTokenProvider } from '../../context/adding-custom-token.js';
import { AssetsProvider } from '../../context/assets.js';
import { ExchangeFormContextProvider } from '../../context/exchange-form.js';
import { LimitsProvider } from '../../context/limits.js';
import { PrefillsProvider } from '../../context/prefills.js';
import { QuoteProvider } from '../../context/quote.js';
import { ValidationProvider } from '../../context/validation.js';
import ErrorBoundary from '../error-boundary/error-boundary.js';
import useConfig from '../../hooks/use-config.js';
import useExchangeReady from '../../hooks/use-exchange-ready.js';
import useFromAsset from '../../hooks/use-from-asset.js';
import useOrigin from '../../hooks/use-origin.js';
import useSetInitialPair from '../../hooks/use-set-initial-pair.js';
import useToAsset from '../../hooks/use-to-asset.js';
const Root = ({ config, params, children }) => {
    useConfig(config);
    useSetInitialPair(params);
    const [, setOrigin] = useOrigin();
    useEffect(() => {
        if (params?.origin) {
            setOrigin(params.origin);
        }
    }, [setOrigin, params]);
    return (React.createElement(AddingCustomTokenProvider, null,
        React.createElement(AssetsProvider, null,
            React.createElement(LimitsProvider, null,
                React.createElement(PrefillsProvider, null,
                    React.createElement(QuoteProvider, null,
                        React.createElement(ValidationProvider, null, children)))))));
};
const SafeRoot = ({ config, fallback = React.createElement(React.Fragment, null), params, children }) => {
    const isReady = useExchangeReady();
    const [, _setFromAsset, resetFromAsset] = useFromAsset();
    const [, _setToAsset, resetToAsset] = useToAsset();
    const handleError = useCallback((error, info) => {
        console.error('ExchangeUI crash', error, info);
        resetFromAsset();
        resetToAsset();
    }, [resetFromAsset, resetToAsset]);
    return (React.createElement(ErrorBoundary, { onError: handleError }, isReady ? (React.createElement(Root, { config: config, params: params }, children)) : (fallback)));
};
const ContextRoot = ({ config, params, children }) => (React.createElement(ExchangeFormContextProvider, null,
    React.createElement(SafeRoot, { config: config, params: params }, children)));
export default ContextRoot;
